import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SuitDiamondMark } from './BrandMarks';
import './Header.css';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
      <div className="header-inner container">
        <Link to="/" className="header-logo" onClick={close} aria-label="The Pantry Life home">
          <span className="header-logo-mark" aria-hidden="true">
            <SuitDiamondMark size={28} />
          </span>
          <span className="header-logo-word">The Pantry Life</span>
        </Link>

        <nav className={`header-nav${menuOpen ? ' header-nav--open' : ''}`} aria-label="Main navigation">
          <NavLink to="/" end className="nav-link" onClick={close}>Apps</NavLink>
          <NavLink to="/support" className="nav-link" onClick={close}>Support</NavLink>
          <NavLink to="/privacy" className="nav-link" onClick={close}>Privacy</NavLink>
        </nav>

        <button
          className="header-hamburger"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(v => !v)}
        >
          <span className={`bar${menuOpen ? ' bar--open' : ''}`} />
        </button>
      </div>
    </header>
  );
}
